import City from "model/political/city";
import Territory from "model/political/territory";
const ActionType = "TradePost";

const generosityTooltip = (generosity) => {
  const generosityLevel = Object.keys(City.Generosity).find((key) =>
    City.Generosity[key] === generosity
  );
  return [`Generosity: ${generosityLevel} - affects prices.`];
};

const attitudeTooltip = (attitude) => {
  const attitudeLevel = Object.keys(Territory.Attitude).find((key) =>
    Territory.Attitude[key] === attitude
  );
  return [
    `Attitude: ${attitudeLevel} - affects shop availability and service.`,
  ];
};

const attempt = (context) => {
  // Logic to determine the outcome of the shop visit
  // Example: Special item found if generosity is high
  const generosity = context.political.generosity(context.party.city);
  if (generosity === City.Generosity.Generous) {
    // TODO: Special Item Found
    return { success: true, specialItemFound: true };
  }

  return { success: true };
};

const executeSideEffects = (context, result) => {
  const { party } = context;
  const { history } = party;

  history.add({ action: ActionType, result }, context);
  if (result.specialItemFound) {
    // TODO: Add special item to inventory
  }

  return {};
};

const TradePost = ({ context }) => {
  const generosity = context.political.generosity(context.party.city);
  const attitude = context.political.attitude(
    context.party.territory,
    context.party.traits.getTraitValue("charisma"),
  );
  // Logic to determine if the shop is accessible
  const isShopAccessible = () => {
    // The shop is only accessible if the city's attitude is not Hostile
    const hasHorse = context.party.resources.items.horse.value;
    return attitude !== Territory.Attitude.Hostile || !hasHorse;
  };

  return {
    title: "Trade Post",
    hotkey: "T",
    type: ActionType,
    enabled: isShopAccessible,
    execute: (context) => {
      const result = attempt(context);
      executeSideEffects(context, result);

      return {};
    },
    tooltips: [generosityTooltip(generosity), attitudeTooltip(attitude)],
  };
};

export { ActionType, TradePost as default };
